<template>
    <div class="edit_wrap">
        <div class="add_top">
            <div class="add_tab active_tab">合同详情</div>
        </div>
        <div class="pl10 mt20 mb20" v-if="contractForm.schedule">
            <el-row>
                <el-col :span="2">
                    <div class="grid-content">审核进展：</div>
                </el-col>
                <el-col :span="22"><div class="grid-content"><span class="main_word">{{ contractForm.schedule.time*1000 | time }}&nbsp;&nbsp;{{ contractForm.schedule.desc}}</span></div></el-col>
            </el-row>
            <el-row>
                <el-col :span="22" :offset="2"><div class="grid-content" v-if="contractForm.schedule.content">
                    ({{contractForm.schedule.content}})</div></el-col>
            </el-row>
        </div>
        <div class="mt20 ovh min_height">
            <div class="pl10 mt20">
                <span class="dib">合同基本信息</span><span class="line"></span>
                <div class="mt20">
                    <el-form :model="contractForm" ref="contractForm" label-width="207px" class="demo-ruleForm mt10">
                        <el-form-item label="供应商合同编号："><span>{{ contractForm.contractCode }}</span></el-form-item>
                        <el-form-item label="供应商原合同编号：" v-if="contractForm.parentContractId>0"><span>{{ contractForm.parentContractCode }}</span></el-form-item>
                        <el-form-item label="供应商编号："><span>{{ contractForm.supplierCode }}</span></el-form-item>
                        <el-form-item label="供应商名称："><span>{{ contractForm.supplierName }}</span></el-form-item>
                        <el-form-item label="合作方式：" prop="cooperationType"
                                      :rules="[
                                      { required: true, message: '请选择合作方式'}]"
                        >
                            <el-select @change="" v-model="contractForm.cooperationType" prop="cooperationType"
                                       placeholder="请选择合作方式" :disabled="contractForm.parentContractId>0">
                                <el-option label="入仓" :value="1"></el-option>
                                <el-option label="入仓（实销实结）" :value="2"></el-option>
                                <el-option label="自发货" :value="3"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="contractForm.cooperationType==3" label="发货时效：">
                            <span class="main_word rule_star92">*</span>
                            <el-select class="ml_10" v-model="contractForm.deliveryTime"
                                       placeholder="请选择发货时效">
                                <el-option label="48小时" :value="48"></el-option>
                                <el-option label="72小时" :value="72"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="合同开始时间：">
                            <el-date-picker :disabled="contractForm.parentContractId>0" v-model="contractForm.contractStartDate"
                                            type="date" placeholder="请选择合同开始时间">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="合同结束时间：">
                            <el-date-picker v-model="contractForm.contractEndDate"
                                            type="date" placeholder="请选择合同结束时间">
                            </el-date-picker>
                        </el-form-item>

                        <span class="dib">合同条款-财务信息</span><span class="second_line"></span>
                        <el-form-item label="结算主体：" prop="settlementBodyId" :rules="[
                                      { required: true, message: '请选择结算主体'}]">
                            <template scope="scope">
                                <el-select :disabled="contractForm.parentContractId>0" class="w193" v-model="contractForm.settlementBodyId"
                                           placeholder="请选择结算主体">
                                    <el-option label="北京果敢时代科技有限公司" :value="1"></el-option>
                                    <el-option label="MAMA HONG KONG" :value="2" ></el-option>
                                    <el-option label="天津果敢时代国际贸易有限公司" :value="3"></el-option>
                                    <!--<el-option label="正合奇胜（天津）企业咨询管理有限公司" :value="4"></el-option>-->
                                    <el-option label="老师线下打款" :value="5"></el-option>
                                </el-select>
                            </template>
                        </el-form-item>
                        <el-form-item label="结算方式：" prop="settlementType" :rules="[
                                      { required: true, message: '请选择结算方式'}]">
                            <template scope="scope">
                                <el-select :disabled="contractForm.parentContractId>0" class="w193" v-model="contractForm.settlementType"
                                           placeholder="请选择结算方式">
                                    <el-option v-show="contractForm.cooperationType ==1" label="直采" :value="1"></el-option>
                                    <el-option v-show="contractForm.cooperationType ==1" label="预付款" :value="2"></el-option>
                                    <el-option v-show="contractForm.cooperationType !=1" label="实销实结" :value="3"></el-option>
                                </el-select>
                            </template>
                        </el-form-item>

                        <el-form-item label="结算币种：">
                            <span class="main_word rule_star92">*</span>
                            <span class="ml_10">人民币</span>
                        </el-form-item>
                        <el-form-item v-if="contractForm.settlementType == 1 || contractForm.settlementType == 3"
                                      label="结算账期：" prop="settlementPaymentType" :rules="{ required: true,type:'number',message:'请选择结算账期类型'}">
                            <el-select class="w193" v-model="contractForm.settlementPaymentType">
                                <el-option label="按年结算" :value="2"></el-option>
                                <el-option label="按半年结算" :value="3"></el-option>
                                <el-option label="按季度结算" :value="4"></el-option>
                                <el-option label="按月结算" :value="5"></el-option>
                                <el-option label="按半月结算" :value="6"></el-option>
                                <el-option label="自定义" :value="0"></el-option>
                            </el-select>
                            <el-input v-if="contractForm.settlementPaymentType===0" class="w193" v-model.number="contractForm.settlementPaymentDays" placeholder="请输入结算天数" :maxlength="4"></el-input>
                            <span v-if="contractForm.settlementPaymentType===0">天</span>
                        </el-form-item>
                        <el-form-item v-if="contractForm.settlementType == 2" label="结算账期：">
                            <el-button type="primary" @click="addDomain">添加分期付款比例</el-button>
                        </el-form-item>
                        <el-form-item v-if="contractForm.settlementType == 2" class="ml60 mt20"
                                      v-for="(domain, index) in contractForm.settlementPaymentRateArr"
                                      :label="'第' + (index+1) + '期'"
                                      :key="'settlementPaymentRate'+index"
                                      :prop="'settlementPaymentRateArr'+'[' + index + ']'"
                                      :rules="{required: true, message:'请输入正确分期付款比例', trigger: 'blur'}"
                        >
                            <el-input class="w70" v-model="contractForm.settlementPaymentRateArr[index]" @input="contractForm.settlementPaymentRateArr[index]=contractForm.settlementPaymentRateArr[index].replace(/[^\-?\d.]/g,'')"></el-input>%
                            <el-button @click.prevent="removeDomain(domain)">删除</el-button>
                        </el-form-item>
                        <!--是否需要保证金-->
                        <el-form-item label="是否需要保证金：">
                            <span class="main_word rule_star133">*</span>
                            <el-radio-group :disabled="contractForm.parentContractId>0" class="ml_10" v-model="contractForm.shouldDeposit" @change="">
                                <el-radio :label="0"><span class="f14 f666">供应商无需交保证金</span></el-radio>
                                <el-radio :label="1"><span class="f14 f666">供应商需交保证金</span></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!--保证金-->
                        <el-form-item v-if="contractForm.shouldDeposit == 1" label="保证金：" prop="deposit" :rules="{ required: true,type:'number',message:'请填写正确的保证金'}">
                            <el-input class="w193" v-model.number="contractForm.deposit" placeholder="" :maxlength="10" :disabled="contractForm.parentContractId>0"></el-input>
                            人民币
                        </el-form-item>
                        <el-form-item label="货款支付方式：">
                            <span class="main_word rule_star120">*</span>
                            <span class="ml_10">甲方将货款直接支付到乙方的如下银行账户</span>
                        </el-form-item>
                        <el-table :data="contractForm.accounts" border
                                  ref="singleTable" style="width: 90%;margin: 0 auto;margin-bottom:22px;margin-top: 22px" highlight-current-row
                                  @current-change="handleCurrentChange">
                            <el-table-column min-width="100" align="center">
                                <template scope="scope">
                                    <el-radio class="radio" v-model="contractForm.bankAccountId" :label="scope.row.id">&nbsp;</el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column label="银行开户名" min-width="200" align="center" prop="accountName">
                            </el-table-column>
                            <el-table-column prop="accountNumber" label="银行帐号" min-width="200" align="center">
                            </el-table-column>
                            <el-table-column prop="bankName" label="银行名称" min-width="200" align="center">
                            </el-table-column>
                            <el-table-column v-if="contractForm.registeredCountry != 1" prop="swiftCode" label="SwiftCode" min-width="200" align="center">
                            </el-table-column>
                            <el-table-column v-if="contractForm.registeredCountry == 1" prop="province" label="省" min-width="200" align="center">
                            </el-table-column>
                            <el-table-column v-if="contractForm.registeredCountry == 1" prop="city" label="市" min-width="200" align="center">
                            </el-table-column>
                        </el-table>

                        <span class="dib">线上合同信息</span><span class="line"></span>

                        <!--选择线上合同-->
                        <div v-if="!contractForm.parentContractId">
                            <el-button class="ml115 mt20" type="primary"  @click="selectAgree" v-if="contractForm.auth.edit">选择线上合同</el-button>
                            <span class="main_word"> （请为供应商选择合同，之后直接在线上完成合同相关信息填写）</span>
                        </div>
                        <div style="margin-left: 150px;margin-top: 20px">
                            <div class="agree_wrap" v-for="val in contractTemplate.templateContents">
                                <div class="in_block">
                                    <span class="agree">{{ val.name }}</span>
                                    <el-button v-if="contractForm.auth.edit" type="primary" @click="editAgree(val)">编辑</el-button>
                                </div>
                            </div>
                        </div>

                        <!--合同弹框-->
                        <el-dialog title="合同线上模板" :visible.sync="contractTemplate.agreeDialog" size="large">
                            <div class="block">
                                <div class="clearfix container">
                                    <div class="row">
                                        <div class="col-lg-3" v-for="val in contractTemplate.list" style="width:20%;">
                                            <el-radio-group v-model="contractTemplate.fatherId" @change="argeenSel">
                                                <el-radio :label="val.id"><span class="f16 fwb">{{ val.name }}</span></el-radio>
                                            </el-radio-group>
                                            <div class="mt20">
                                                <template v-for="va in val.subList">
                                                    <div class="mt10">
                                                        <el-radio-group v-model="contractTemplate.childrenId"
                                                                        @change="argeenChildrenSel">
                                                            <el-radio :label="va.id">{{ va.name }}</el-radio>
                                                        </el-radio-group>
                                                        <br>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="contractTemplate.agreeDialog = false">取 消</el-button>
                                <el-button type="primary" @click="saveAgree">确认模板</el-button>
                            </div>
                        </el-dialog>

                        <div align="center" class="auto mt10 mb10">
                            <el-button type="primary" class="mr10" @click="cancle">取消</el-button>
                            <el-button v-if="contractForm.auth.edit" class="mr10" type="primary" @click="save">暂存</el-button>
                            <el-button v-if="contractForm.auth.edit && contractForm.parentContractId>0" class="mr10" type="primary" @click="submit('contractForm')">推送采销</el-button>
                            <el-button v-if="contractForm.auth.push" class="mr10" type="primary" @click="submit('contractForm')">推送供应商</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>


</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                // pickerOptions: {
                //     disabledDate(time) {
                //         return time.getTime() < Date.now();
                //     }
                // },
                contractTemplate:{
                    agreeDialog: false,

                    fatherId: 0,
                    childrenId: 0,
                    templateContents: [],
                    list: [
                        {
                            id: null, //模板id
                            pid: null,
                            name: "",//模板名称
                            fileName: "", //模板文件
                            status: 0,
                            subList: [ //子模板
                            ]
                        }
                    ]
                },
                contractId:0,
                contractForm: {
                    id: 0,
                    parentContractId:0,
                    parentContractCode:'',
                    supplierName:'',
                    supplierCode:'',
                    contractName: '',
                    contractCode: '',
                    contractStartDate:'',
                    contractEndDate: '',
                    deliveryTime:'',
                    cooperationType:'',
                    settlementBodyId:1,
                    settlementType:'',
                    settlementPaymentType:0,
                    settlementPaymentDays: null,
                    settlementPaymentRate:'',
                    settlementPaymentRateArr: [''],
                    contractFileArr:[''],
                    shouldDeposit: 1,
                    bankAccountId:0,
                    deposit: null,
                    accounts:[],
                    account:{},
                    templateContents: [],
                    templateContentIds:[],
                    auth:{
                        view:false,
                        edit:false,
                        del:false,
                        push:false,
                        confirm:false,
                        saleAudit:false,
                        inspectorAudit:false,
                        forensicAudit:false,
                        financeAudit:false,
                        confirmDepositAuth:false,
                        confirmContractAuth:false
                    },
                    schedule:null
                }
            };
        },
        methods: {
            editAgree(val){
                var data = {};
                data = JSON.parse(JSON.stringify(this.contractForm));
                var _this = this;
                if (!data.contractStartDate) {
                    this.$message.error("请选择合同开始日期");
                    return;
                }
                if (!data.contractEndDate) {
                    this.$message.error("请选择合同结束日期");
                    return;
                }
                if (!_this.contractForm.bankAccountId) {
                    _this.$message.error('请选择一个货款支付账号');
                    return;
                }
                var contractStartTime = new Date(data.contractStartDate)
                var contractEndTime = new Date(data.contractEndDate)
                var stTime = contractStartTime.getFullYear() + "-" + (contractStartTime.getMonth() + 1) + "-" + contractStartTime.getDate();
                var endTime = contractEndTime.getFullYear() + "-" + (contractEndTime.getMonth() + 1) + "-" + contractEndTime.getDate();
                var account = [];
                for(var key in _this.contractForm.accounts){
                    var _account = _this.contractForm.accounts[key];
                    if (_account.id === _this.contractForm.bankAccountId) {
                        account = _account;
                    }
                }
                window.open("/suppliers/index2/#/" + val.fileName + "_edit?type=2&contentId=" + val.contentId
                    + "&templateId=" + val.templateId
                    + "&parentContractId=" + this.contractForm.parentContractId +
                    "&bankName=" + account.bankName +
                    "&accountNumber=" + account.accountNumber +
                    "&accountName=" + account.accountName +
                    "&startTime=" + stTime +
                    "&endTime=" + endTime +
                    "&deposit=" + this.contractForm.deposit +
                    "&suppliersName=" + this.contractForm.supplierName +
                    "&agreementCode=" + this.contractForm.contractCode

                );
            },
            // 添加分期付款比率
            addDomain() {
                if(this.contractForm.settlementPaymentRateArr.length == 10){
                    this.$message.error('当前结算账期最多可添加10个');
                    return;
                }
                this.contractForm.settlementPaymentRateArr.push("");
            },
            removeDomain(item) {
                var index = this.contractForm.settlementPaymentRateArr.indexOf(item);
                if (index !== -1) {
                    this.contractForm.settlementPaymentRateArr.splice(index, 1)
                }
            },
            submit(formName){
                var _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (_this.contractForm.settlementType == 2) {
                            if (_this.contractForm.settlementPaymentRateArr.length == 0) {
                                _this.$message.error('分期付款比例不能为空');
                                return;
                            }
                            var sum = 0;
                            for (var i = 0; i < _this.contractForm.settlementPaymentRateArr.length; i++) {
                                var rate = _this.contractForm.settlementPaymentRateArr[i];
                                if (rate == '') {
                                    _this.$message.error('分期付款比例不能为空');
                                    return;
                                }
                                rate = rate * 1;
                                if (!typeof(rate) == "number") {
                                    _this.$message.error('分期付款比例必须为数字');
                                    return;
                                }
                                sum += rate;
                            }
                            if (sum != 100) {
                                _this.$message.error('所有期的百分比加起来必须是100%');
                                return;
                            }

                        } else {
                            if(_this.contractForm.settlementPaymentType===0&&(_this.contractForm.settlementPaymentDays==null||_this.contractForm.settlementPaymentDays===0)){
                                _this.$message.error('请输入结算账期天数');
                                return;
                            }
                        }

                        if(!_this.contractForm.bankAccountId){
                            _this.$message.error('请选择一个货款支付账号');
                            return;
                        }

                        if (_this.contractForm.templateContentIds && _this.contractForm.templateContentIds.length != _this.contractTemplate.templateContents.length) {
                            _this.$message.error('请填写线上合同内容');
                            return;
                        }
                        if(_this.contractForm.settlementPaymentType >= 2){
                            _this.contractForm.settlementPaymentDays = 1;
                        }

                        var data = {};
                        data = JSON.parse(JSON.stringify(_this.contractForm));

                        if(data.contractStartDate && data.contractEndDate){
                            data.contractStartDate = new Date(data.contractStartDate).getTime()/1000;
                            data.contractEndDate = new Date(data.contractEndDate).getTime()/1000;
                        }

                        if (data.contractStartDate && data.contractEndDate){
                            if (data.contractStartDate > data.contractEndDate) {
                                _this.$message.error('合同结束时间不能小于合同开始时间');
                                return;
                            }
                        }
                        $.ajax({
                            url: '/suppliers/agreementApply/contractApply/push',
                            data: JSON.stringify(data),
                            dataType: "json",
                            contentType: 'application/json;charset=utf-8',
                            type: 'POST',
                            success: function (result) {
                                if (result.code == 0) {
                                    _this.$message({
                                        message: '推送成功',
                                        type: 'success'
                                    });
                                    _this.fetch();
                                } else {
                                    _this.$message({
                                        message: result.msg,
                                        type: 'error'
                                    });
                                }
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            save () {
                var _this = this;
                if(this.contractForm.settlementPaymentType >= 2){
                    this.contractForm.settlementPaymentDays = 1;
                }
                var data = {};
                data = JSON.parse(JSON.stringify(this.contractForm));
                // if(data.contractStartDate && data.contractEndDate){
                //     data.contractStartDate = new Date(data.contractStartDate).getTime()/1000;
                //     data.contractEndDate = new Date(data.contractEndDate).getTime()/1000;
                // }
                if(data.contractStartDate){
                    data.contractStartDate = new Date(data.contractStartDate).getTime()/1000;
                }
                if(data.contractEndDate){
                    data.contractEndDate = new Date(data.contractEndDate).getTime()/1000;
                }

                if (data.contractStartDate && data.contractEndDate){
                    if (data.contractStartDate > data.contractEndDate) {
                        this.$message.error('合同结束时间不能小于合同开始时间');
                        return;
                    }
                }
                $.ajax({
                    url: '/suppliers/agreementApply/contractApply/save',
                    data: JSON.stringify(data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (result.code == 0) {
                            _this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                        } else {
                            _this.$message({
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            fetch () {
                var that = this;
                $.get({
                    url: '/suppliers/agreementApply/contractApply/detail',
                    data: {
                        contractId: that.contractId
                    },
                    success: function(result) {
                        if (!result.code) {
                            console.log(result);
                            that.contractForm = result.data.agreement;

                            if(!that.contractForm.auth.edit){
                                that.$router.push({
                                    path:'/contract_view?contractId=' + that.contractId
                                 });
                            }

                            if(that.contractForm.contractStartDate ){that.contractForm.contractStartDate = that.contractForm.contractStartDate*1000;}
                            if(that.contractForm.contractEndDate){that.contractForm.contractEndDate = that.contractForm.contractEndDate*1000}

                            that.contractTemplate.templateContents = that.contractForm.templateContents;
                            that.contractForm.templateContentIds = [];
                            for(var i =0;i < that.contractForm.templateContents.length;i++){
                                that.contractForm.templateContentIds.push(that.contractForm.templateContents[i].contentId);
                            }

                            that.$watch('contractForm.settlementType', that.settlementTypeChange);
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            // 请求合同模板列表
            getAgreeList () {
                var _this = this;
                $.get({
                    url: '/suppliers/contract/template/list',
                    success: function (result) {
                        if (result.code == 0) {
                            _this.contractTemplate.list = result.data;
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },
            //选择线上合同
            selectAgree(){
                this.contractTemplate.agreeDialog = true;
                if (!this.contractTemplate.templateContents) {
                    this.contractTemplate.fatherId = 0;
                    this.contractTemplate.childrenId = 0;
                } else {
                    for (var x = 0; x < this.contractTemplate.templateContents.length; x++) {
                        for (var i = 0; i < this.contractTemplate.list.length; i++) {
                            if (this.contractTemplate.templateContents[x].templateId == this.contractTemplate.list[i].id) {
                                this.contractTemplate.fatherId = this.contractTemplate.list[i].id;
                                continue;
                            }
                            if (this.contractTemplate.list[i].subList) {
                                for (var j = 0; j < this.contractTemplate.list[i].subList.length; j++) {
                                    var sub = this.contractTemplate.list[i].subList[j];
                                    if (this.contractTemplate.templateContents[x].templateId == sub.id) {
                                        this.contractTemplate.childrenId = sub.id;
                                        continue;
                                    }
                                }
                            }
                        }
                    }
                }
            },
            // 确认模板
            saveAgree (){
                if (!this.contractTemplate.fatherId) {
                    this.$message.error('请选择一个合同模板');
                    return;
                }
                if (!this.contractTemplate.childrenId) {
                    for (var i = 0; i < this.contractTemplate.list.length; i++) {
                        var father = this.contractTemplate.list[i];
                        if (father.id == this.contractTemplate.fatherId && this.contractTemplate.list[i].subList && this.contractTemplate.list[i].subList.length > 0) {
                            this.$message.error('当前选择的合同模板包含附加协议，请选择一个附加协议');
                            return;
                        }
                    }
                }
                this.contractTemplate.templateContents = [];
                this.contractForm.templateContentIds = [];

                for (var i = 0; i < this.contractTemplate.list.length; i++) {
                    var father = this.contractTemplate.list[i];
                    if (father.id == this.contractTemplate.fatherId) {
                        this.contractTemplate.templateContents.push({
                            contentId: 0,
                            templateId: father.id,
                            name: father.name,
                            fileName: father.fileName
                        });
                        this.contractForm.contractName = father.name;
                    }
                    if (this.contractTemplate.list[i].subList) {
                        for (var j = 0; j < this.contractTemplate.list[i].subList.length; j++) {
                            var sub = this.contractTemplate.list[i].subList[j];
                            if (this.contractTemplate.childrenId == sub.id) {
                                this.contractTemplate.templateContents.push({
                                    contentId: 0,
                                    templateId: sub.id,
                                    name: sub.name,
                                    fileName: sub.fileName
                                });
                                break;
                            }
                        }
                    }
                }
                this.contractTemplate.agreeDialog = false;
            },
            argeenSel (val) {
                if (this.contractTemplate.childrenId == 0) {
                    return;
                }
                for (var i = 0; i < this.contractTemplate.list.length; i++) {
                    if (this.contractTemplate.list[i].subList) {
                        for (var j = 0; j < this.contractTemplate.list[i].subList.length; j++) {
                            var sub = this.contractTemplate.list[i].subList[j];
                            if (this.contractTemplate.childrenId == sub.id && val != sub.pid) {
                                this.contractTemplate.childrenId = 0;
                                break;

                            }
                        }
                    }
                }
            },
            argeenChildrenSel (val) {
                for (var i = 0; i < this.contractTemplate.list.length; i++) {
                    if (this.contractTemplate.list[i].subList) {
                        for (var j = 0; j < this.contractTemplate.list[i].subList.length; j++) {
                            var sub = this.contractTemplate.list[i].subList[j];
                            if (val == sub.id) {
                                this.contractTemplate.fatherId = sub.pid;
                                break;
                            }
                        }
                    }
                }
            },
            handleCurrentChange(val) {
                this.contractForm.bankAccountId = val.id;
            },
            cancle(){
                window.close();
            },
            settlementTypeChange(val){
                if (val == 2) {
                    this.contractForm.settlementPaymentDays = null;
                    this.contractForm.settlementPaymentType = 1;
                }else{
                    this.contractForm.settlementPaymentType = 5;
                }
            }
        },
        watch: {
            'contractForm.cooperationType': function (val) {
                if(val!=3) {
                    this.contractForm.deliveryTime = null;
                }
                if (val == 1 && this.contractForm.settlementType == 3) {
                    this.contractForm.settlementType = null;
                } else if ((val == 2 || val == 3)) {
                    this.contractForm.settlementType = 3;
                }
            },
            'contractForm.contractStartDate': function (val) {
                if (this.contractForm.contractEndDate && val) {
                    if (this.contractForm.contractEndDate < val) {
                        this.$message.error('合同结束时间不能小于合同开始时间');
                    }
                }
            },
            'contractForm.contractEndDate': function (val) {
                if (this.contractForm.contractStartDate && val) {
                    if (val < this.contractForm.contractStartDate) {
                        this.$message.error('合同结束时间不能小于合同开始时间');
                    }
                }
            }
        },
        mounted () {
            var contractId = this.$route.query.contractId;
            this.contractId = contractId;
            this.getAgreeList();
            this.fetch();
        },
        created () {
            var _this = this;
            window.eventHub.$on('SET_CONTENT_ID', (data) => {
                if (_this.contractTemplate.templateContents) {
                    if (!_this.contractForm.templateContentIds) {
                        _this.contractForm.templateContentIds = [];
                    }
                    for (var x = 0; x < _this.contractTemplate.templateContents.length; x++) {
                        if (parseInt(data.templateId) === _this.contractTemplate.templateContents[x].templateId) {
                            _this.contractTemplate.templateContents[x].contentId = data.contentId;
                            if(_this.contractForm.templateContentIds.indexOf(data.contentId) == -1){
                                _this.contractForm.templateContentIds.push(data.contentId);
                            }
                        }
                    }
                }
            })
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .line {
            display: inline-block;
            margin-left: 3%;
            width: 88%;
            height: 1px;
            border-bottom: 1px dashed #999;
            vertical-align: middle;
        }

        .second_line {
            display: inline-block;
            margin-left: 3%;
            width: 85%;
            height: 1px;
            border-bottom: 1px dashed #666;
            vertical-align: middle;
        }

        .word_num {
            display: inline-block;
            margin-bottom: 22px;
            margin-left: 5px;
            color: #666;
            vertical-align: bottom;
        }

        .pic_tip {
            position: absolute;
            top: 100%;
            left: 0;
            padding-top: 4px;
            color: #ff4949;
            font-size: 12px;
            line-height: 1px;
        }

        .pic_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 150px;
            height: 150px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }

        .pic_min_skan {
            box-sizing: border-box;
            margin-top: 5px;
            width: 60px;
            height: 60px;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            cursor: pointer;
        }

        .form_color {
            color: rgb(106, 72, 77);
        }

        .el-form-item {
            margin-bottom: 20px;
        }

        .edit_wrap {
            margin: 50px auto;
            width: 1050px;
            border: 1px solid #eee;
            .edit_tab {
                display: inline-block;
                width: 262px;
                height: 46px;
                background: #ff6c83;
                color: #fff;
                text-align: center;
                line-height: 46px;
            }
            .tip_word {
                margin-top: 20px;
                padding: 10px;
                width: 1048px;
                height: 160px;
                background: #f9f9f9;
            }
        }

        .el-form-item {
            margin-top: 10px;
        }

        .w193 {
            width: 193px;
        }

        .w70 {
            width: 70px;
        }

        .w160 {
            width: 160px;
        }

        .ml115 {
            margin-left: 115px;
        }

        .agree_wrap {
            display: inline-block;

        }

        .in_block {
            margin-left: 20px;
        }

        .agree {
            display: inline-block;
            min-width: 100px;

        }
        .rule_star78 {
            position: relative;
            left:-78px;
        }
        .rule_star92 {
            position: relative;
            left:-92px;
        }
        .rule_star120 {
            position: relative;
            left:-120px;
        }
        .rule_star133 {
            position: relative;
            left:-133px;
        }
        .ml_10 {
            margin-left: -10px;
        }
        .fwb {
            font-weight: bold;
        }
        .lh20 {
            line-height: 20px;
        }
        .add_top {
            width: 100%;
            height: 40px;
            background-color: #f9f9f9;
        }
        .add_tab {
            display: inline-block;
            width: 170px;
            height: 40px;
            color: #666;
            text-align: center;
            font-size: 14px;
            line-height: 40px;
            cursor: pointer;
        }
        .active_tab {
            border-bottom: 1px solid #ff4a7d;
            color: #ff4a7d;
        }
</style>


// WEBPACK FOOTER //
// agreement_edit.vue?53e0dd86